import api from './api';

// Generate or retrieve session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('owlfit_session');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('owlfit_session', sessionId);
  }
  return sessionId;
};

// Track analytics event
export const trackEvent = async (type, data = {}) => {
  try {
    const sessionId = getSessionId();
    await api.post('/analytics/track', {
      type,
      sessionId,
      ...data
    });
  } catch (error) {
    // Silently fail - analytics shouldn't break the app
    console.debug('Analytics tracking error:', error.message);
  }
};

// Track page view
export const trackPageView = (page, category = null) => {
  trackEvent('pageview', { page, category });
};

// Track product view
export const trackProductView = (productId, category = null) => {
  trackEvent('product_view', { productId, category });
};

// Track add to cart
export const trackAddToCart = (productId, metadata = {}) => {
  trackEvent('add_to_cart', { productId, metadata });
};

// Track checkout
export const trackCheckout = (metadata = {}) => {
  trackEvent('checkout', { metadata });
};

// Track purchase
export const trackPurchase = (orderId, metadata = {}) => {
  trackEvent('purchase', { metadata: { orderId, ...metadata } });
};

export default {
  trackEvent,
  trackPageView,
  trackProductView,
  trackAddToCart,
  trackCheckout,
  trackPurchase
};
